import {Injectable, Inject} from 'ng-metadata/core';

@Injectable()
export class PopupMessageService {

    constructor(@Inject('$http') private $http: ng.IHttpService,
                @Inject('restBaseURLs') private restBaseURLs) {
    }

    public callPrimoServer(time){
        let dataToBeSent = { extendTime: time };
        return this.$http.get(this.restBaseURLs.extendSession, {params: dataToBeSent});
    }

}

//put here all angular1 modules the service is using
export default [];



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/popupMessage/popupMessage.service.ts